<template>
  <div class="day-item">
    <span class="day">{{ dayjs(invoiceDetail.eventedAt).format('YY. MM .DD (ddd)') }}</span>
    <ul class="day-list">
      <li>
        <div class="info-top flex-btw">
          <p class="dim2">{{ formatDateTimeByLocale(invoiceDetail.eventedAt) }}</p>
          <!-- <p>{{ invoiceDetail.startDate }}</p> -->
          <p>{{ textTag }}</p>
        </div>
        <div class="info-bottom flex-btw">
          <p>{{ getLabel(invoiceDetail) }}</p>
          <strong class="accent price">
            {{ getTextCredit(invoiceDetail.amount) }}
          </strong>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';

import dayjs from 'dayjs';

import IconCheck from '@/components/icons/IconCheck.vue';
import IconClose from '@/components/icons/IconClose.vue';
import IconPlus from '@/components/icons/IconPlus.vue';
import { IResponsePaymentHistory } from '@/types/response';
import { formatNumberWithComma } from '@/utils/stringUtils.js';
import formatDateTimeByLocale from '@/utils/common/formatDateTimeByLocale';
import { CHAT_LABEL_KEY_MAP } from '@/utils/constants/chat';

const { t } = useI18n();

const { invoiceDetail } = defineProps<{
  invoiceDetail: IResponsePaymentHistory;
}>();

const isTypePurchase = ref(invoiceDetail.canceledAmount === 0); // 결제 완료 건인지

// 결제 완료 / 결제 취소 반환
const textTag = computed(() => {
  const mapClass = {
    CHARGE: t('ss_invoice_type_topup'),
    USAGE: t('label_use'),
    CANCEL: t('label_cancel'),
  };
  return mapClass[invoiceDetail.type];
});

// 태그 아이콘 반환
const iconTag = computed(() => {
  return {
    CHARGE: IconPlus,
    USAGE: IconCheck,
    CANCEL: IconClose,
  }[invoiceDetail.type];
});

// 태그 클래스 반환
const typeTag = computed(
  () => {
    const mapClass = {
      CHARGE: 'info-light',
      USAGE: 'success-light',
      CANCEL: 'error-light',
    };
    return mapClass[invoiceDetail.type];
  }
  //   isTypePurchase.value ? 'info-light' : 'gray-light'
);

const getLabel = (invoiceDetail) => {
  if (invoiceDetail.type === 'USAGE') {
    const labelKey = CHAT_LABEL_KEY_MAP[invoiceDetail.chatType];
    return labelKey ? t(labelKey) : '';
  }

  if (invoiceDetail.type === 'CHARGE') {
    return t('add_credit');
  }

  return '';
};

// 금액 문구 반환
const getTextCredit = (amount: number) => `${formatNumberWithComma(amount)} ${t('credit')}`;
</script>

<style scoped lang="scss">
.container-invoicehistory {
  position: relative;
  display: flex;
  width: 100%;
  justify-content: space-between;
  text-align: left;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid var(--border-default);

  @include respond-to(mobile-portrait) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 1rem 0;
    gap: 0.5rem;
  }
}

.wrapper-info {
  display: flex;
  gap: 1rem;
  align-items: center;

  @include respond-to(mobile-portrait) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
}

.day-item {
  margin-top: 1.5rem;
  &:first-child {
    margin: 0;
  }
  .day {
    display: block;
    font-size: $font-size-psmall;
    margin-bottom: 0.5rem;
  }
  .day-list {
    border-top: 1px solid $color-gray-900;
    li {
      border-bottom: 1px solid $color-gray-40;
      padding: 1rem 0.25rem;

      .info-top {
        margin-bottom: 0.25rem;
        p {
          font-size: $font-size-psmall;
        }
      }
      .info-bottom {
        strong,
        p {
          font-weight: 600;
        }
        .price {
          &.plus {
            color: $meeting;
          }
        }
      }
    }
  }
}
</style>
